import React from 'react';
import { useSelector } from 'react-redux';
import { Col, Container, Row } from '@yme/atoms/grid';
import { IndentWrapper } from '@yme/components/Separator';
import { useWindowSize } from '@yme/hooks/useWindowSize';
import { CardForEvents } from '@yme/molecules/cards/card-for-events';
import { getCommonLabels, getRTL } from '@yme/selectors/common';
import { buildKey } from '@yme/utils/common';
import { isCardEmpty } from './helpers';
import { ColStyled, TitleStyled } from './styled';
export function TwoCards(props) {
    const { title, cards, isRemoveBottomIndent, isFullWidth } = props;
    const isRightToLeft = useSelector(getRTL);
    const labels = useSelector(getCommonLabels);
    const { isInfiniteDesktopView } = useWindowSize();
    const prepareCards = cards.filter((card) => !isCardEmpty(card));
    if (!prepareCards?.length) {
        return null;
    }
    const cardSize = isFullWidth ? 6 : 4;
    return (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent },
        React.createElement(Container, null,
            title && (React.createElement(Row, { justifyContent: "center" },
                React.createElement(Col, { lg: isFullWidth ? 12 : 8 },
                    React.createElement(TitleStyled, null, title)))),
            React.createElement(Row, { justifyContent: isInfiniteDesktopView ? 'center' : 'flex-start' },
                prepareCards.map((card, index) => {
                    return (React.createElement(ColStyled, { key: buildKey(card.title, index), isRightToLeft: isRightToLeft, lg: cardSize, md: cardSize },
                        React.createElement(CardForEvents, { cardProps: {
                                title: card.title,
                                link: card.link,
                                image: card.image,
                                description: card.description,
                                labelLink: labels?.common_readMore_link || '',
                                countLineVisible: 'initial',
                                isFullHeaderVisible: true,
                            }, isRightToLeft: isRightToLeft })));
                }),
                isInfiniteDesktopView && prepareCards.length === 1 && React.createElement(Col, { lg: cardSize })))));
}
TwoCards.displayName = 'TwoCards_AEMComponent';
